import React from 'react';

// Styles
import styles, * as E from './styles';

export default class UpdatesDetail extends React.Component {
  render() {
    return (
      <E.Container>
        <E.Inner>
          <E.Title>{`Version 2.2.5`}</E.Title>
          <E.Desc>{`RELEASED OCTOBER 10, 2021`}</E.Desc>
          <E.SubTitle>{`Multi Users Management`}</E.SubTitle>
          <E.Desc_1>{`IMPLEMENTATION`}</E.Desc_1>
          <E.UL>
            <E.LI>Adding Organization Directory section in Account Settings to support to multi-user management under organization account.</E.LI>
          </E.UL>
        </E.Inner>
        <E.Inner>
          <E.Title>{`Version 2.2.7`}</E.Title>
          <E.Desc>{`RELEASED JANUARY 07, 2022`}</E.Desc>
          <E.SubTitle>{`Display Timezone`}</E.SubTitle>
          <E.Desc_1>{`IMPLEMENTATION`}</E.Desc_1>
          <E.UL>
            <E.LI>Display shipment time zone on shipment time window/ETA/drop-off and shipment history.</E.LI>
          </E.UL>
        </E.Inner>
      </E.Container>
    );
  }
}
